import { Link } from 'react-router-dom';

import SubPageLayout from './SubPageLayout';

export default function NotFound() {
  return (
    <SubPageLayout backTo="/">
      <section className="not-found container">
        <h1 className="gradient-text">404</h1>
        <p>Looks like this page took a different flight.</p>
        <Link to="/" className="btn btn--primary">
          Go to the homepage
        </Link>
      </section>
    </SubPageLayout>
  );
}
